var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel_not_data"},[_c('dl',{staticClass:"image_text"},[_c('dt',[_c('img',{attrs:{"src":require(`../../assets/img/not-data/${_vm.imgName}.png`)}})]),_c('dd',[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }